export const NavBarItemstyle = {
  color: "#AEAEB2",
  fontfamily: "-apple-system, BlinkMacSystemFont, sans-serif",
  visibility: "true",
  width: "auto",
  left: "-16px",
  paddingTop: "8px",
  paddingBottom: "8px",
  paddingLeft: "-16px",
  paddingRight: "16px",
  display: "flex",
  gap: "24px",
};

export const NavBarSubItemstyle = {
  color: "#AEAEB2",
  fontfamily: "-apple-system, BlinkMacSystemFont, sans-serif",
  visibility: "true",
  width: "auto",
  paddingLeft: 35,
};

export const NavBarItemClickStyle = {
  width: "auto",
  cursor: "pointer",
};
